"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyselfSection = void 0;
var _components = require("@ori-ui/components");
var _react = require("react");
var _contexts = require("../../contexts");
var _types = require("../../types");
var _FormattedMessage = require("../FormattedMessage");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MyselfSection = ({
  selected,
  value,
  onChange
}) => {
  const {
    customerType
  } = (0, _react.useContext)(_contexts.wizardContext);
  if (customerType === _types.EWizardCustomerType.OnlyForOtherCustomers) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ToggleCard, {
    checked: selected,
    name: "consultant-option",
    type: "radio",
    id: "myself",
    value: value,
    onChange: onChange,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SelectedBoldTypography, {
      ownerState: {
        selected
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "myself"
      })
    })
  });
};
exports.MyselfSection = MyselfSection;
